import { initReactI18next } from "react-i18next";
import i18n from "i18next";

import { SUPPORTED_LANGUAGES, type SupportedLang } from "./config";
import ar from "./locales/ar.json";
import be from "./locales/be.json";
import bg from "./locales/bg.json";
import cs from "./locales/cs.json";
import de from "./locales/de.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import he from "./locales/he.json";
import it from "./locales/it.json";
import ja from "./locales/ja.json";
import pl from "./locales/pl.json";
import pt from "./locales/pt.json";
import ru from "./locales/ru.json";
import zh from "./locales/zh.json";

const RTL_LANGS = new Set(["he", "ar"]);

function applyDocumentDir(lang: string) {
  document.documentElement.dir = RTL_LANGS.has(lang) ? "rtl" : "ltr";
  document.documentElement.lang = lang;
}

const savedLang = localStorage.getItem("lang");
const supported = Object.keys(SUPPORTED_LANGUAGES) as SupportedLang[];

export const browserLang: SupportedLang =
  supported.find((lang) => navigator.language.startsWith(lang)) ?? "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ru: { translation: ru },
    fr: { translation: fr },
    de: { translation: de },
    es: { translation: es },
    be: { translation: be },
    bg: { translation: bg },
    cs: { translation: cs },
    it: { translation: it },
    ja: { translation: ja },
    pl: { translation: pl },
    pt: { translation: pt },
    zh: { translation: zh },
    he: { translation: he },
    ar: { translation: ar },
  },
  lng: savedLang || browserLang,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

applyDocumentDir(i18n.language);
i18n.on("languageChanged", applyDocumentDir);

export default i18n;
